import { createAction } from 'redux-actions';

import { SET_MAIN_ERROR, SET_APP_ERROR, RESET_ERRORS } from './types';

export const setMainError = createAction(SET_MAIN_ERROR);
export const setAppError = createAction(SET_APP_ERROR);
export const resetErrors = createAction(RESET_ERRORS);
